import TabsPage from '../TabsPage';

import ContentBlock from "components/ContentBlock";
import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";

import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';
import { ReactComponent as PrintIcon } from 'icons/buttons/print.svg';
import { ReactComponent as SpecialInfoIcon } from 'icons/components/specialInfo.svg';

import './index.less';
import './themes/default.less';

export default class PhotoProtokol extends TabsPage {

    constructor(props) {
        super(props);

        this.rglist = {
            "RG_18_17_16": { labelUp: "18 17 16" },
            "RG_16_15_14": { labelUp: "16 15 14" },
            "RG_48_47_46": { labelDown: "48 47 46" },
            "RG_46_45_44": { labelDown: "46 45 44" },
            "RG_17_16": { labelUp: "17 16", labelDown: "47 46" },
            "RG_15_14": { labelUp: "15 14", labelDown: "45 44" },
            "RG_14_13_12": { labelUp: "14 13 12" },
            "RG_11_21": { labelUp: "11 21" },
            "RG_22_23_24": { labelUp: "22 23 24" },
            "RG_36_37_38": { labelDown: "36 37 38" },
            "RG_34_35_36": { labelDown: "34 35 36" },
            "RG_24_25_26": { labelUp: "24 25 26" },
            "RG_26_27_28": { labelUp: "26 27 28" },
            "RG_24_25": { labelUp: "24 25", labelDown: "34 35" },
            "RG2_24_25": { labelUp: "27 28", labelDown: "36 37" },
            "RG_44_43_42": { labelDown: "44 43 42" },
            "RG_41_31": { labelDown: "41 31" },
            "RG_32_33_34": { labelDown: "32 33 34" },
            "none1": {},
            "none2": {},
            "none3": {},
        };

        this.protlist = {
            "LOCAL_PHOTO_UP": "localPhotoTop",
            "OCLUSION_UP": "topOcclusion",
            "LOCAL_PHOTO_UP2": "localPhotoTop2",
            "FRONT_CONTRAST_UP": "frontContrasterh",
            "SIDE_BYTE_ONE_FOUR": "Lateral14",
            "FRONT_BYTE": "FrontBite",
            "SIDE_BYTE_TWO_THREE": "Lateral23",
            "LOCAL_PHOTO_DOWN": "localPhotoBottom",
            "LOCAL_PHOTO_DOWN2": "localPhotoBottom2",
            "OCLUSION_DOWN": "bottomOcclusion",
            "FRONT_CONTRAST_DOWN": "frontContrastern",
            "FRONT_TEETH_OCCLUSION": "occlusionAnterior",
            "OCCLUSION_RIGHT": "rightOcclusion",
            "OCCLUSION_MOLARS_RIGHT": "occlusionPainters",
        };

        this.state = {
            ...this.state,
            currentItem: { id: false, items: false },
            absol: true
        };

        this.useTooltip = true;

        this.elementRefs = {};

    }

    componentDidMount() {
        this.refresh();

        super.componentDidMount();
    }

    refresh() {
        this.getData();
    }

    async getData() {
        this._helper.showLoading();
        const { currentItem } = this.state;

        const { id } = this.props.info;
        //const resp = await this._request.visits.getForClient(id, "-endDate", false, ["WI_CREATED", "WI_REPLACED", "WI_COMPLETED"]);
        const filterCanceled = false;
        const resp = await this._request.visits.getForPlanClient(id, filterCanceled);
        const items = resp?.data || [];
        //const respRengD = await this._request.rentgenDoze.getRentgenDose();

        if (items.length > 0) {
            const cindex = currentItem.id ? items.findIndex(it => it.id === currentItem.id) : "-1";
            const ci = {
                id: items[cindex !== "-1" ? cindex : 0].id,
                items: this.formatItemsToObject(items[cindex !== "-1" ? cindex : 0].fileStorage),
                photoRgDosage: items[cindex !== "-1" ? cindex : 0].photoRgDosage,
                photoComment: items[cindex !== "-1" ? cindex : 0].photoComment,
            };

            this.setState({ items, currentItem: ci });
        } else {
            this.setState({ items });
        }

        this._helper.hideLoading();
    }

    async updateVisit(visitId, info) {
        this._helper.showLoading();

        await this._request.visits.update(visitId, info);
        this.refresh();

        this._helper.hideLoading();
    }

    async deletePhoto(id) {
        this._helper.showLoading();
        await this._request.files.deletep(id, {});
        this.refresh();

        this._helper.hideLoading();
    }

    saveComment({ comment }) {
        const { currentItem } = this.state;
        if (currentItem.id)
            this.updateVisit(currentItem.id, { photoComment: comment });
    }

    async saveDose(dose) {
        const { currentItem } = this.state;

        //await this._request.rentgenDoze.add()

        if (currentItem.id)
            this.updateVisit(currentItem.id, { photoRgDosage: dose });

    }

    scrollMenu(index) {
        if (this.elementRefs[index]?.scrollIntoView)
            this.elementRefs[index].scrollIntoView({ behavior: 'smooth' });
    }

    onTagClick(key, index, indScr, e) {
        if (index === this.state.currentItem.index)
            this._helper.stopEvent(e);

        this.changeState("currentItem", key, this.scrollMenu.bind(this, indScr));
    }

    onChangeCurrentItem(key) {
        this.changeState("currentItem", key);
    }

    formatItemsToObject(items) {

        const itemsObject = items.reduce((acc, it) => {
            const position = it.position === "RG_PANORAM" ? `RG_PANORAM${it.id}` :
                ((it.category === "RG_CAT_ID" || it.category === "PROTOCOL_CAT_ID") && !it.position) ? `OTHERPHOTO${it.id}` : it.position;
            acc[position] = {
                path: it.thumpSource,
                category: it.category,
                comment: it.comment,
                pathBig: it.source,
                id: it.id,
                uuid: it.uuid4,
            };
            return acc;
        }, {});

        return itemsObject;
    }

    renderItem(it, key, index) {
        return (
            <div
                key={"it_" + key}
                className={`rowItem rad8 hand`}
                onClick={this.onTagClick.bind(this, key, index, it.index)}>
                {it.title}
            </div>
        );
    }

    renderRowsMenu(info, key) {
        const { beginDate, endDate, doctorId, fileStorage, id, photoRgDosage, photoComment } = info;
        const { currentItem } = this.state;

        const period = this._helper.date.toPeriodStr(beginDate, endDate);
        const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId), "short");
        const row1 = `${period}, ${doctor}`;

        const row2 = [];
        if (fileStorage?.some(it => it.position !== null && it.category === "RG_CAT_ID"))
            row2.push({ title: this.tr("client.rgInspection"), index: 0 });
        if (fileStorage?.some(it => it.position === "RG_PANORAM"))
            row2.push({ title: this.tr("client.rgPanorama"), index: 1 });
        if (fileStorage?.some(it => (it.category === "PROTOCOL_CAT_ID" && it.position !== "RG_PANORAM")))
            row2.push({ title: this.tr("client.photoProtocol"), index: 3 });
        if (photoRgDosage)
            row2.push({ title: this.tr("client.dose"), index: 2 });
        if (fileStorage?.some(it => it.position === null && it.category === "RG_CAT_ID"))
            row2.push({ title: this.tr("client.otherPhotos"), index: 4 });
        if (photoComment)
            row2.push({ title: this.tr("client.comment"), index: 5 });

        return (
            <div
                key={key}
                className={`rowMenu flex gap8 rad4 ${currentItem.id === id ? "active" : ""}`}
                onClick={this.changeState.bind(this, "currentItem", {
                    id, photoComment, photoRgDosage,
                    items: this.formatItemsToObject(fileStorage)
                })}>
                <div className="details flex1 flex col gap8">
                    <div className="text p1SemiBold">{row1}</div>
                    <div className="menuRow2 flex wrap text p2SemiBold gap8">
                        {row2.map((it, j) => this.renderItem(it, j, key))}
                    </div>
                </div>
            </div>
        );
    }

    openDialogFileUpload({ key, category, path, pathBig, idPhoto, comment }) {
        const { currentItem } = this.state;
        const { id, domainId } = this.props.info;

        const clinic = this._helper.getClinicNameById(domainId);

        const info = {
            infoFile: {
                domainId: domainId,
                domain: clinic,
                visitId: currentItem.id,
                clientId: id,
                category: category,
                position: key === "OTHERPHOTO" ? "" : key,
            },
            title: "client.uploadFile",
            accept: "image/jpeg, image/png",
            name: key,
            path,
            pathBig,
            id: idPhoto,
            comment
        };

        this.props.openDialog("fileUpload", info, this.refresh.bind(this));
    }

    onChangeNotes(info) {
        this.props.openDialog("changeNote", info, this.saveComment.bind(this));
    }

    onChangeDose(info) {
        this.props.openDialog("dose", info, this.saveDose.bind(this));
    }

    openImage(src, e) {
        const { currentItem } = this.state;
        const list = Object.keys(currentItem.items).map(it => currentItem.items[it]?.pathBig);
        this._helper.stopEvent(e);
        this._helper.showImageBox(false, src, list);
    }

    async downloadImg(imageUrl, imageName) {
        await this._request.images.downloadImg(imageUrl, imageName);
    }

    renderAddImg(title, key, category) {
        return (<div className="flex centerV col pos rel" onClick={this.openDialogFileUpload.bind(this, { key, category })}>
            <PlusIcon />
            {this.tr(`client.${title}`)}
        </div>);
    }

    renderImg(info, key) {
        const { category, pathBig, path, id, uuid, comment } = info;

        return (<div
            key={"img" + key}
            className={`${(category === "RG_CAT_ID" || key.includes("RG_PANORAM") || key.includes("OTHERPHOTO")) ? "contImage" : "contImageProt"} pos rel icon flex centerH endV hidden`}
            onClick={this.openImage.bind(this, pathBig)}>
            <img
                className="pos abs sideAll"
                src={path}
                alt={key}
            />
            <div className="dotsButtCont pos abs hand">
                <ButtonIconSelect
                    size="mini"
                    type="dots"
                    stopEvent={true}
                    translate={true}
                    items={[
                        { name: "client.open", onClick: this.openImage.bind(this, pathBig) },
                        { name: "client.download", onClick: this.downloadImg.bind(this, pathBig, key) },
                        { name: "client.editData", onClick: this.openDialogFileUpload.bind(this, { key, category, path, pathBig, idPhoto: id, comment }) },
                        { name: "client.delete", onClick: this.deletePhoto.bind(this, uuid) },
                    ]}
                />
            </div>

        </div>);
    }

    renderPhotoComm(comment) {
        return (<div className="photoComm pos abs rad2">
            <div className="ttip flex" data-tooltip={comment}>
                <SpecialInfoIcon />
            </div>
        </div>);
    }

    renderBlockRG(key, labelUp, labelDown, i) {
        const { items } = this.state.currentItem;

        return (
            <div key={"blockRG" + (key ? key : i)} className={`blockPhoto pos rel text p2SemiBold rad4 ${(!labelUp && !labelDown) ? "none" : ""}`}>
                {labelUp && <div className="mainLabel pos abs rad4">{labelUp}</div>}
                {labelDown && <div className="mainLabel down pos abs rad4">{labelDown}</div>}
                <div className="contentPhoto h100 flex centerAll hand">
                    {items[key] && items[key].comment && this.renderPhotoComm(items[key].comment)}
                    {items[key] ? this.renderImg(items[key], key) : this.renderAddImg("addPhoto", key, "RG_CAT_ID")}
                </div>
            </div>
        );
    }

    renderBlockPhoto(key, title, category, empty = false) {
        const { items } = this.state.currentItem;

        return (!empty && items[key] ?
            <div key={"blockphoto" + key} className={`blockPhoto pos rel text p2SemiBold rad4`}>
                <div className="contentPhoto h100 flex centerAll hand">
                    {items[key].comment && this.renderPhotoComm(items[key].comment)}
                    {this.renderImg(items[key], key)}
                </div>
            </div> :
            <div key={"blockphoto" + key} className={`blockPhoto pos rel text p2SemiBold rad4`}>
                <div className="contentPhoto h100 flex centerAll hand">
                    {this.renderAddImg(title, key, category)}
                </div>
            </div>
        );
    }

    renderRowRg(fotoRow) {
        return (<div className="flex between gap16">
            {fotoRow.map(it => this.renderBlockRG(it, this.rglist[it].labelUp, this.rglist[it].labelDown))}
        </div>);
    }

    renderRgInspection() {
        const fotoRow1 = ["RG_18_17_16", "RG_16_15_14", "RG_14_13_12", "RG_11_21", "RG_22_23_24", "RG_24_25_26", "RG_26_27_28"];
        const fotoRow2 = ["RG_17_16", "RG_15_14", "none1", "none2", "none3", "RG_24_25", "RG2_24_25"];
        const fotoRow3 = ["RG_48_47_46", "RG_46_45_44", "RG_44_43_42", "RG_41_31", "RG_32_33_34", "RG_34_35_36", "RG_36_37_38"];

        return (
            <div className="rgInspection flex col gap24 scrolling all">
                {this.renderRowRg(fotoRow1)}
                {this.renderRowRg(fotoRow2)}
                {this.renderRowRg(fotoRow3)}
            </div>
        );
    }

    renderRgPanorama() {
        const { items } = this.state.currentItem;
        return (
            <div className="flex gap16">
                {Object.keys(items).map((it, j) => it.includes("RG_PANORAM") && <div key={"rgpanorama" + j} className={`blockPhoto pos rel text p2SemiBold rad4`}>
                    <div className="contentPhoto h100 flex centerAll hand">
                        {items[it].comment && this.renderPhotoComm(items[it].comment)}
                        {this.renderImg(items[it], it)}
                    </div>
                </div>
                )}
                {this.renderBlockPhoto("RG_PANORAM", "addPhoto", "PROTOCOL_CAT_ID", true)}
            </div>
        );
    }

    renderPhotoProtocol() {
        return (
            <div className="photoProtocol flex wrap gap16">
                {Object.entries(this.protlist).map(([key, value]) => this.renderBlockPhoto(key, value, "PROTOCOL_CAT_ID"))}
            </div>
        );
    }

    renderOtherPhoto() {
        const { items } = this.state.currentItem;
        return (
            <div className="flex gap16 wrap">
                {Object.keys(items).map((it, j) => it.includes("OTHERPHOTO") && <div key={"rgpanorama" + j} className={`blockPhoto pos rel text p2SemiBold rad4`}>
                    <div className="contentPhoto h100 flex centerAll hand">
                        {items[it].comment && this.renderPhotoComm(items[it].comment)}
                        {this.renderImg(items[it], it)}
                    </div>
                </div>
                )}
                {this.renderBlockPhoto("OTHERPHOTO", "addPhoto", "RG_CAT_ID", true)}
            </div>
        );
    }

    renderRightColumn() {
        const { photoComment, photoRgDosage } = this.state.currentItem;
        this.elementRefs = {};

        return (
            <>
                <ContentBlock
                    Ref={el => this.elementRefs[0] = el}
                    title="client.rgInspection"
                >
                    {this.renderRgInspection()}
                </ContentBlock>
                <ContentBlock
                    Ref={el => this.elementRefs[1] = el}
                    title="client.rgPanorama"
                >
                    {this.renderRgPanorama()}
                </ContentBlock>
                {photoRgDosage ? <ContentBlock
                    Ref={el => this.elementRefs[2] = el}
                    title="client.dose"
                    icon={{ name: "edit", onClick: this.onChangeDose.bind(this, photoRgDosage) }}
                >
                    {`${photoRgDosage.title}: ${photoRgDosage.value}`}
                </ContentBlock> :
                    <ContentBlock
                        Ref={el => this.elementRefs[2] = el}
                        title="client.dose"
                        border="dashed"
                        icon={{ name: "plus", onClick: this.onChangeDose.bind(this, false) }}
                    />}
                <ContentBlock
                    Ref={el => this.elementRefs[3] = el}
                    title="client.photoProtocol"
                >
                    {this.renderPhotoProtocol()}
                </ContentBlock>
                <ContentBlock
                    Ref={el => this.elementRefs[4] = el}
                    title="client.otherPhotos"
                >
                    {this.renderOtherPhoto()}
                </ContentBlock>
                {photoComment ? (
                    <ContentBlock
                        Ref={el => this.elementRefs[5] = el}
                        title="client.comment"
                        icon={{ name: "edit", onClick: this.onChangeNotes.bind(this, { comment: photoComment }) }}
                    >
                        <div className="text p1">{photoComment}</div>
                    </ContentBlock>
                ) : (
                    <ContentBlock
                        Ref={el => this.elementRefs[5] = el}
                        title="client.comment"
                        icon={{ name: "plus", onClick: this.onChangeNotes.bind(this, {}) }}
                        border="dashed"
                    >
                    </ContentBlock>
                )}
            </>
        );
    }

    renderContent() {
        const { items } = this.state;
        return (<div className="tabsPage flex flex1 minH0 pos rel">
            <div className="flex flex1 pos abs sideAll">
                <div className="leftColumn flex">
                    <div className="flex col flex1 gap32 ">
                        <div className="flex end">
                            <Button
                                type={"secondary"}
                                size={"small"}
                                label={"client.doseLoad"}
                                icon={<PrintIcon />}
                                tooltip="main.print"
                                onClick={this.printShow.bind(this, "X-ray", { clientId: this.props.info.id + "" })}
                            />
                        </div>
                        <div className="leftMenu flex flex1 col gap8 scrolling">
                            {items && items.length > 0 && items?.map((it, i) => this.renderRowsMenu(it, i))}
                        </div>
                    </div>
                </div>
                <div className="rightColumn flex flex1 col gap16 scrolling">
                    {(items && items.length > 0) ? this.renderRightColumn() : items ? <div>{this.tr("client.noVisits")}</div> : <div>{this.tr("client.getData")}</div>}
                </div>
            </div>
        </div>);
    }
}
